export default __webpack_public_path__ + "static/media/illustration-recruit-6-w@3x.bc9b5d94.webp";